import script from "./ChooseLocationPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChooseLocationPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__